import React, { useCallback } from 'react';

interface Props {
  color?: string;
}

export const EyeClosed: React.FC<Props> = ({ color }) => {
  const renderColor = useCallback(() => {
    return color || '#000';
  }, [color]);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="11" fill="none" viewBox="0 0 20 11">
      <path
        fill={renderColor()}
        d="M1.43.6a.872.872 0 011.176.368c.414.791 1.485 1.803 2.922 2.63 1.422.819 3.049 1.366 4.465 1.366 1.415 0 3.043-.547 4.464-1.365 1.438-.828 2.508-1.84 2.922-2.631a.872.872 0 011.545.808c-.28.535-.709 1.072-1.236 1.583l2.009 1.726a.872.872 0 01-1.137 1.322L16.318 4.48a13.33 13.33 0 01-1.842 1.08l1.387 2.606a.872.872 0 01-1.54.818l-1.471-2.767c-.654.213-1.323.366-1.987.44v2.847a.872.872 0 11-1.743 0V6.658a10.09 10.09 0 01-1.976-.436l-1.47 2.762a.872.872 0 11-1.539-.818l1.384-2.6a13.672 13.672 0 01-1.846-1.08L1.44 6.407A.872.872 0 01.303 5.085l2.001-1.72c-.53-.512-.961-1.052-1.242-1.59A.872.872 0 011.43.6z"
      ></path>
    </svg>
  );
};
